'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStreamMessage = createStreamMessage;
exports.reportStreamStatus = reportStreamStatus;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _webApiClientSingleton = require('../webApiClientSingleton');

var _webApiClientSingleton2 = _interopRequireDefault(_webApiClientSingleton);

var _logging = require('../player/constants/logging');

var _logCategoryActionLabel = require('./logCategoryActionLabel');

var _logCategoryActionLabel2 = _interopRequireDefault(_logCategoryActionLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var streamIndexMsg = 'idx';
var shoutcastHackMsg = 'shoutcastHack';
var shoutcastHackExtraTimeMsg = 'shoutcastHackExtraTime';
var m3uExtensionRemovedMsg = 'm3uExtensionRemoved';
var hlsFormatIncorrectMsg = 'hlsFormatIncorrect';

function createStreamMessage() {
  var stream = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var index = stream.index,
      isHlsFormatIncorrect = stream.isHlsFormatIncorrect,
      removedM3UExtension = stream.removedM3UExtension,
      isShoutcastHack = stream.isShoutcastHack,
      isFinalStream = stream.isFinalStream;

  var streamDetails = [streamIndexMsg + '=' + index];

  if (isHlsFormatIncorrect) {
    streamDetails.push(hlsFormatIncorrectMsg);
  }

  if (removedM3UExtension) {
    streamDetails.push(m3uExtensionRemovedMsg);
  }

  if (isShoutcastHack) {
    if (isFinalStream) {
      streamDetails.push(shoutcastHackExtraTimeMsg);
    } else {
      streamDetails.push(shoutcastHackMsg);
    }
  }

  return streamDetails.join(':');
}

function reportStreamStatus(listenId) {
  var stream = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var tune = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var err = arguments[3];
  var duration = arguments[4];
  var onlyHttpStreams = arguments[5];

  var streamMessage = createStreamMessage(stream);
  var id = tune.guideId,
      itemToken = tune.itemToken,
      formats = tune.formats;
  var streamGuideId = stream.id,
      format = stream.format;


  var reportData = {
    c: 'stream',
    id: id,
    streamGuideId: streamGuideId,
    itemToken: itemToken,
    formats: formats,
    listenId: listenId,
    format: format,
    onlyHttpStreams: onlyHttpStreams
  };

  if (err) {
    reportData.error = 1000;
    // NOTE: across all partners, the message query param actually denotes an error message for
    // a stream error. Hence, a separate, successMessage query param needed to be created to
    // accommodate stream success messages.
    reportData.message = streamMessage + '|' + err.message;
    reportData.duration = (0, _get2.default)(err, 'errorData.duration');
  } else {
    reportData.successMessage = streamMessage;
    reportData.duration = duration;
  }

  _webApiClientSingleton2.default.instance.logging.report(reportData);
  if (onlyHttpStreams) {
    (0, _logCategoryActionLabel2.default)({
      category: _logging.categories.web,
      action: _logging.actions.mixedContentUpgrade,
      label: err ? _logging.labels.fail : _logging.labels.success
    }, {
      id: id,
      streamGuideId: streamGuideId,
      itemToken: itemToken,
      listenId: listenId,
      format: format
    });
  }
}
//# sourceMappingURL=streamStatus.js.map